
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class WebsiteOrderProductsDialog extends Serenity.EntityDialog<WebsiteOrderProductsRow, any> {
        protected getFormKey() { return WebsiteOrderProductsForm.formKey; }
        protected getIdProperty() { return WebsiteOrderProductsRow.idProperty; }
        protected getLocalTextPrefix() { return WebsiteOrderProductsRow.localTextPrefix; }
        protected getNameProperty() { return WebsiteOrderProductsRow.nameProperty; }
        protected getService() { return WebsiteOrderProductsService.baseUrl; }
        protected getDeletePermission() { return WebsiteOrderProductsRow.deletePermission; }
        protected getInsertPermission() { return WebsiteOrderProductsRow.insertPermission; }
        protected getUpdatePermission() { return WebsiteOrderProductsRow.updatePermission; }

        protected form = new WebsiteOrderProductsForm(this.idPrefix);

    }
}